// extracted by mini-css-extract-plugin
export default {"container":"Header_container__TsUVY","headName":"Header_headName__J9aqJ"};